import { useUpdateInvitationModal } from "@/features/update-invitation"
import { RoleType } from "@/shared/api/users"
import { FC } from "react"

interface CreateInvitationProps {
    onCreate: () => void,
    role: RoleType
}

export const CreateInvitation: FC<CreateInvitationProps> = ({ onCreate, role }) => {
    const { openCreateInvitationModal } = useUpdateInvitationModal()

    return (
        <button onClick={() => openCreateInvitationModal(role, onCreate)} className="filter_button !w-fit">
            Создать приглашение
        </button>
    )
}